import { combineReducers } from 'redux'
import { createActionThunk } from 'redux-thunk-actions'
import { handleActions } from 'redux-actions'
import debounceAction from 'debounce-action'
import _ from 'lodash'

import all_deposits from './all_deposits'
import api from 'core/api'
import { prepare_coin_number } from 'core/utils'
import parametersSelector from 'selectors/parameters'

const getType = type => `@calculations/prices/${type}`

export const getPricesThunk = createActionThunk(getType('FETCH'), api('/calculations/prices'))

let previousPricesArgument
export const getPricesThunkSmart = (value, force) => dispatch => {
  if (!force && _.isEqual(previousPricesArgument, value)) return Promise.resolve()
  previousPricesArgument = value
  return dispatch(getPricesThunk(value, force))
}

export const getPrices = (value, force) => (dispatch, getState) => {
  const parameters = parametersSelector(getState())
  const coin_amount = parseFloat(prepare_coin_number(parameters)(value))
  const { token_purchase_type_id } = getState().calculator.buy_tokens_form
  return dispatch(getPricesThunkSmart({ coin_amount, token_purchase_type_id }, force))
}

export const getPricesDebounced = debounceAction(getPrices, 300)

export const initialState = { json: {}, loading: false }

const reducer = handleActions(
  {
    [getPricesThunk.START]: state => ({ ...state, loading: true }),
    [getPricesThunk.SUCCEEDED]: (state, { payload }) => ({ ...state, ...payload }),
    [getPricesThunk.ENDED]: state => ({ ...state, loading: false })
  },
  initialState
)

export default combineReducers({
  index: reducer,
  all_deposits
})



// WEBPACK FOOTER //
// ./src/modules/calculations/prices/index.js